<script setup lang="ts">
const route = useRoute()

const items = computed(() => [{
  label: 'Kurse',
  to: '/kurs',
  active: route.path.startsWith('/kurs'),
  children: [{
    label: 'Kurse für Eltern',
    to: '/kurs/eltern',
    description: 'Digitale Sicherheit und Medienkompetenz für Familien',
    icon: 'i-lucide-users'
  }, {
    label: 'Kurse für Senioren',
    to: '/kurs/senioren',
    description: 'Einfacher Einstieg in Smartphone, Tablet und Internet',
    icon: 'i-lucide-heart-handshake'
  }, {
    label: 'Web Development',
    to: '/kurs/web-dev',
    description: 'Moderne Webentwicklung für Einsteiger und Fortgeschrittene',
    icon: 'i-lucide-code-2'
  }, {
    label: 'Smart Home',
    to: '/kurs/smart-home',
    description: 'Intelligente Geräte und Heimautomation verständlich erklärt',
    icon: 'i-lucide-house-plus'
  }, {
    label: 'Allgemeines',
    to: '/kurs/allgemein',
    description: 'Infoanlässe, Web Pro & Friends und weitere Formate',
    icon: 'i-lucide-calendar-days'
  }]
}, {
  label: 'Lehrgänge',
  to: '/lehrgang',
  active: route.path.startsWith('/lehrgang'),
  children: [{
    label: 'KI-Coding: Einstieg',
    to: '/lehrgang/coden-mit-ki-einstieg',
    description: 'Erste Website bauen mit KI-Agent – 2-Tages-Workshop',
    icon: 'i-lucide-bot'
  }, {
    label: 'Web Foundation',
    to: '/lehrgang/foundation',
    description: 'Das Fundament, um mit KI-Agenten zu bauen',
    icon: 'i-lucide-rocket'
  }, {
    label: 'Web Developer',
    to: '/lehrgang/developer',
    description: 'Vom Prompter zum Architekten – echte Anwendungen mit KI',
    icon: 'i-lucide-code-2'
  }]
}, {
  label: 'Über uns',
  to: '/ueber-uns',
  active: route.path.startsWith('/ueber-uns'),
  children: [{
    label: 'Team',
    to: '/ueber-uns/team',
    description: 'Wer steckt hinter den Web Professionals, inklusive Dozenten',
    icon: 'i-lucide-users'
  }, {
    label: 'Community',
    to: '/ueber-uns/community',
    description: 'Web Pro & Friends, Barcamps & Hackathons',
    icon: 'i-lucide-network'
  }]
}, {
  label: 'Blog',
  to: '/blog'
}, {
  label: 'FAQ',
  to: '/faq'
}, {
  label: 'Kontakt',
  to: '/kontakt'
}])
</script>

<template>
  <UHeader>
    <template #left>
      <NuxtLink
        to="/"
        aria-label="Web Professionals — zur Startseite"
      >
        <AppLogo class="w-auto h-10 shrink-0" />
      </NuxtLink>
    </template>

    <UNavigationMenu
      :items="items"
      variant="link"
      :ui="{
        viewportWrapper: 'absolute top-full left-1/2 -translate-x-1/2 w-screen max-w-(--ui-container) px-4 sm:px-6 lg:px-8 flex'
      }"
    />

    <template #right>
      <UColorModeButton />
      <!--
            <UButton
              icon="i-lucide-log-in"
              color="neutral"
              variant="ghost"
              to="/login"
              class="lg:hidden"
            />

            <UButton
              label="Sign in"
              color="neutral"
              variant="outline"
              to="/login"
              class="hidden lg:inline-flex"
            />

            <UButton
              label="Sign up"
              color="neutral"
              trailing-icon="i-lucide-arrow-right"
              class="hidden lg:inline-flex"
              to="/signup"
            />
            -->
    </template>

    <template #body>
      <UNavigationMenu
        :items="items"
        orientation="vertical"
        class="-mx-2.5"
        :ui="{ link: 'text-[1.3125rem] py-3' }"
      />
<!--
      <USeparator class="my-6" />

      <UButton
        label="Sign in"
        color="neutral"
        variant="subtle"
        to="/login"
        block
        class="mb-3"
      />
      <UButton
        label="Sign up"
        color="neutral"
        to="/signup"
        block
      />
      -->
    </template>
  </UHeader>
</template>
